<template>
  <div class="overflow-content">
    <div class="text" :class="{overflow: height > 100 && !isExpand}" ref="content">{{ content }}</div>
    <span @click="toggle" v-if="!isExpand && height > 100">展开<i class="iconfont icon-down1"></i></span>
    <span @click="toggle" v-if="isExpand && height > 100">收起<i class="iconfont icon-up"></i></span>
  </div>
</template>

<script>
export default {
  name: 'OverflowHiddenComponent',
  props: {
    content: String,
    default () {
      return []
    }
  },
  data () {
    return {
      height: 0,
      isExpand: false
    }
  },
  mounted () {
    this.$nextTick(() => {
      setTimeout(() => {
        console.log(this.$refs.content.clientHeight)
        this.height = this.$refs.content.clientHeight
      },300)
    })
  },
  methods: {

  },
  content: {
    list () {
      this.$nextTick(() => {
        this.height = this.$refs.content.clientHeight
        console.log(this.height)
      })
      
    }
  },
  methods: {
    toggle () {
      this.isExpand = !this.isExpand
    }
  }
}
</script>

<style lang="scss" scoped>
.overflow-content{
  .text{
    line-height: 20px;
    color: $--color-text-secondary;
    &.overflow{
      max-height: 100px;
      overflow: hidden;
    }
  }
  span{
    cursor: pointer;
    color: #949494;
    i{
      margin-left: 6px;
      font-size: 12px;
    }
    // &:hover{
    //   color: $--color-primary;
    // }
  }
}
</style>